import React, { useContext, useState } from "react";
import { FaBox, FaShoppingBag, FaSun, FaMoon, FaBars, FaTimes } from "react-icons/fa";
import ThemeContext from "../contexts/ThemeContext";
import navlogo from "../assets/Navlogo.png";

const AdminSidebar = ({ active, setActive }) => {
  const { isDark, toggleTheme } = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(false); // Mobile toggle local switch state

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/admin";
  };

  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <>
      {/* Mobile view top-bar trigger button (Shows only when drawer is closed on mobile) */}
      <div className={`mobile-top-bar d-lg-none w-100 ${isOpen ? "d-none" : "d-flex"} align-items-center justify-content-between p-3 ${isDark ? "bg-dark text-white border-bottom border-secondary" : "bg-white text-dark shadow-sm"}`}>
        <div className="d-flex align-items-center gap-2">
          <img src={navlogo} alt="AK Logo" style={{ width: "35px", height: "35px", objectFit: "contain" }} />
          <span className="fw-bold small">AK Crackers Admin</span>
        </div>
        <button className="btn btn-outline-secondary p-2" onClick={toggleSidebar}>
          <FaBars size={20} />
        </button>
      </div>

      {/* Main Sidebar Layout Engine */}
      <div
        className={`admin-sidebar p-3 flex-column justify-content-between 
          ${isDark ? "bg-dark text-white border-end border-secondary" : "bg-light text-dark shadow"} 
          ${isOpen ? "d-flex mobile-open position-fixed top-0 start-0 vh-100 z-3" : "d-none d-lg-flex"}`}
        style={{ minHeight: "100vh", width: "260px" }}
      >
        <div>
          {/* Brand Identity Branding Header Area */}
          <div className="d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom opacity-90">
            <div className="d-flex align-items-center gap-2">
              <img src={navlogo} alt="AK Crackers Logo" style={{ width: "45px", height: "45px", objectFit: "contain" }} />
              <span className="fw-bold h6 m-0">AK Crackers Admin</span>
            </div>
            {/* Close button inside mobile slide layout drawer */}
            <button className="btn btn-sm d-lg-none text-muted" onClick={toggleSidebar}>
              <FaTimes size={18} />
            </button>
          </div>

          {/* Navigation Control List Options */}
          <ul className="nav flex-column gap-2">
            <li className="nav-item">
              <button
                onClick={() => { setActive("add"); setIsOpen(false); }}
                className={`nav-link btn w-100 text-start d-flex align-items-center gap-2 border-0 bg-transparent p-2
                  ${active === "add" ? "fw-bold opacity-100" : "opacity-75"}
                  ${isDark ? "text-white" : "text-dark"}`}
              >
                <FaShoppingBag />
                <span>Add Product</span>
              </button>
            </li>

            <li className="nav-item">
              <button
                onClick={() => { setActive("products"); setIsOpen(false); }}
                className={`nav-link btn w-100 text-start d-flex align-items-center gap-2 border-0 bg-transparent p-2
                  ${active === "products" ? "fw-bold opacity-100" : "opacity-75"}
                  ${isDark ? "text-white" : "text-dark"}`}
              >
                <FaBox />
                <span>Products</span>
              </button>
            </li>

            <li className="nav-item">
              <button
                onClick={() => { setActive("orders"); setIsOpen(false); }}
                className={`nav-link btn w-100 text-start d-flex align-items-center gap-2 border-0 bg-transparent p-2
                  ${active === "orders" ? "fw-bold opacity-100" : "opacity-75"}
                  ${isDark ? "text-white" : "text-dark"}`}
              >
                <FaShoppingBag />
                <span>Orders</span>
              </button>
            </li>
          </ul>
        </div>

        {/* Footer Area with Theme Toggle Button & Logout */}
        <div className="mt-auto pt-3 border-top d-flex flex-column gap-3">
          {/* Theme Dynamic Toggle Sync Inside Sidebar */}
          <button
            className={`btn w-100 d-flex align-items-center justify-content-center gap-2 ${isDark ? "btn-outline-light" : "btn-outline-dark"}`}
            onClick={toggleTheme}
          >
            {isDark ? <FaSun size={16} /> : <FaMoon size={16} />}
            <span>{isDark ? "Light Mode" : "Dark Mode"}</span>
          </button>

          <button className="btn btn-danger w-100" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      {/* Mobile Drawer Overlay Background Blur layer */}
      {isOpen && (
        <div className="sidebar-backdrop d-lg-none position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 z-2" onClick={toggleSidebar}></div>
      )}
    </>
  );
};

export default AdminSidebar;